import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const DruhSP = {
	name: NAME,
	apiProvider,
	router,
};
